import { useState } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import ContentLibraryAiChatModal from "components/content_library/ContentLibraryAiChatModal";
import { CreateContentLibraryFolderModal } from "components/content_library/modals/CreateContentLibraryFolderModal";
import UploadContentLibrary from "components/content_library/UploadContentLibrary";
import Card from "components/ui/card/Card";
import Modal from "components/ui/modal/Modal";
import UIcon, { IconProps } from "lib/icons/untitled_ui/UIcon";

type Props = {
  hasDocuments: boolean;
  uiPath: string | undefined; // Only present if we're already in a folder
};

export default function ContentLibraryActionCards({ hasDocuments, uiPath }: Props): JSX.Element {
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const [isAskAiModalOpen, setIsAskAiModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <>
        {hasDocuments ? (
          <Flex gap={16} aria-label="Content library action items">
            {/* TODO: Attach this to ContentLibraryAiChatModal */}
            <ContentLibraryActionItem
              icon="stars2"
              text="Ask Stotles AI"
              onClick={() => setIsAskAiModalOpen(true)}
            />
            {/* TODO: Implement folder creation & saving */}
            <ContentLibraryActionItem
              icon="folderPlus"
              text="New folder"
              onClick={() => setIsCreateModalOpen(true)}
            />
            {/* Implement document upload UI modal */}
            <ContentLibraryActionItem
              icon="upload01"
              text="Upload documents"
              onClick={() => setUploadModalOpen(true)}
            />
          </Flex>
        ) : (
          <ContentLibraryActionItem
            icon="folderPlus"
            text="New folder"
            onClick={() => setIsCreateModalOpen(true)}
            width={160}
          />
        )}
      </>
      <Modal
        open={isUploadModalOpen}
        showCloseButton={false}
        onOpenChange={setUploadModalOpen}
        padding={40}
      >
        <Flex flexDirection="column" gap={24}>
          <Text h1>Upload documents</Text>
          <UploadContentLibrary onClose={() => setUploadModalOpen(false)} uiPath={uiPath} />
        </Flex>
      </Modal>

      <ContentLibraryAiChatModal
        isOpen={isAskAiModalOpen}
        onClose={() => setIsAskAiModalOpen(false)}
      />
      <CreateContentLibraryFolderModal
        isOpen={isCreateModalOpen}
        onOpenChange={(open) => setIsCreateModalOpen(open)}
        uiPath={uiPath}
      />
    </>
  );
}

type ActionItemProps = {
  text: string;
  icon: IconProps["icon"];
  onClick: () => void;
  width?: number;
};
function ContentLibraryActionItem({ text, icon, onClick, width }: ActionItemProps): JSX.Element {
  return (
    <Card height={56} onClick={onClick} borderRadius={8} width={width}>
      <Flex alignItems="center" gap={12} height="100%">
        <IconContainer>
          <UIcon icon={icon} size={16} color="sysPrimaryDefault" />
        </IconContainer>
        <Text>{text}</Text>
      </Flex>
    </Card>
  );
}

const IconContainer = styled(Flex)(({ theme }) => ({
  padding: 8,
  backgroundColor: theme.colors.sysPrimarySubtle,
  borderRadius: 4,
}));
